<template>
<div class="page map-page">
	<map-main-menu />
	<router-view></router-view>
	<my-map />
	<map-type-menu />
</div>
</template>

<script>
import MapMainMenu from './components/MapMainMenu'
import MyMap from './components/MyMap'
import MapTypeMenu from './components/MapTypeMenu'

export default {
	components: {
		MapMainMenu,
		MyMap,
		MapTypeMenu
	}
}
</script>

<style lang="scss">
.map-page {
	.map-sidebar {
		padding: 10px 20px 18px 20px;
		background: rgba(30, 38, 45, 0.95);
		top: 0;
		bottom: 0;
		border-radius: 0;
		position: absolute;
		z-index: 1;
		left: 56px;
		border: none !important;

		hr {
			margin: 18px 0px;
			height: 0px;
			border: none;
			width: 276px;
			border-top: 1px solid #5f8898;
		}
	}
	.brief-detail {
		img {
			width: 60%;
			margin-top: 10px;
		}
		h5 {
			color: #4ba98b;
			margin: 10px 0 13px;
			font-weight: 500;
			font-size: 13px;
			text-align: left;
			line-height: 13px;
		}
		p {
			margin: 0;
			color: #fff;
			font-size: 12px;
			text-align: left;
			font-weight: 200;
			line-height: 13px;

			.key {
				font-weight: 500;
				margin-right: 2px;
			}
		}
	}
}
</style>
